import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';

import type {
  IForgotPasswordTokenSchema,
} from '../types';
import {
  FORGOT_PASSWORD_CONFIRMATION_MUTATION_KEY,
  FORGOT_PASSWORD_CONFIRMATION_URL,
} from '../constants';

export default function useForgotPasswordConfirmationMutation(): IContextMutationResult<void, Error, IForgotPasswordTokenSchema> {
  const { fetchGet } = useRestClient();

  return useContextMutation<void, Error, IForgotPasswordTokenSchema>({
    mutationKey: [FORGOT_PASSWORD_CONFIRMATION_MUTATION_KEY],
    mutationFn: (queryParams) => fetchGet<void>(FORGOT_PASSWORD_CONFIRMATION_URL, {
      queryParams,
    }),
  });
}
